import styled from '@emotion/styled';
import { SPACING } from '@zola/zola-ui/src/styles/emotion';

export const TimeInterval = styled.span<{ addSpacing: boolean }>`
  ${({ addSpacing }) => addSpacing && `margin-left: ${SPACING.S16};`}
`;
